/// <reference types="vite-plugin-svgr/client" />
import { useTranslation } from "react-i18next";
import LogoWithTitlePL from "@monorepo/assets/src/svg/logos/easy-bill-with-title.svg?react";
import { LANGUAGE } from "@monorepo/constants";
import theme from "@monorepo/styles/theme";
import { LanguagesEnum } from "@monorepo/types";
import { List, ListItem, styled, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Logo from "assets/img/logoBig.png";
import BannerImageLT from "assets/img/registrationBannerImage.svg?react";
import BannerImagePL from "assets/img/registrationBannerImagePL.svg?react";

const perlgoBannerTextColor = "#056570";

const StyledListItem = styled(ListItem)(() => ({
  fontSize: theme.typography.body2.fontSize,
  "&::before": {
    content: "''",
    width: "9px",
    height: "9px",
    borderRadius: "50%",
    marginRight: theme.spacing(1),
    backgroundColor: LANGUAGE === LanguagesEnum.PL ? theme.palette.azureishWhite.main : perlgoBannerTextColor,
  },
}));

const RegistrationBanner = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        background: LANGUAGE === LanguagesEnum.LT ? theme.palette.mysticGray.main : theme.palette.white.main,
        width: "100%",
        height: "100%",
        minHeight: "605px",
        color: LANGUAGE === LanguagesEnum.LT ? perlgoBannerTextColor : theme.palette.text.primary,
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "30px",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          pt: 1,
          pl: 2,
          mb: 4,
          mt: 2,
        }}
      >
        {LANGUAGE === LanguagesEnum.PL && <LogoWithTitlePL height={"50px"} />}
        {LANGUAGE === LanguagesEnum.LT && (
          <Box
            component="img"
            src={Logo}
            alt={"common.perlasgo_logo_alt"}
            sx={{ marginRigth: "auto", maxHeight: "70px" }}
          />
        )}
      </Box>
      {LANGUAGE === LanguagesEnum.LT ? <BannerImageLT /> : <BannerImagePL />}
      <Typography
        variant="h6"
        component="p"
        textAlign="center"
        fontWeight="bold"
        sx={{
          fontSize: theme.typography.subtitle1.fontSize,
          maxWidth: "326px",
          marginTop: 5,
          mb: 2,
        }}
      >
        {t("register.banner_title")}
      </Typography>
      {LANGUAGE === LanguagesEnum.LT && (
        <Typography
          fontWeight="bold"
          textAlign="center"
          component="p"
          sx={{
            marginTop: "auto",
            marginBottom: theme.spacing(3),
            fontSize: theme.typography.h5.fontSize,
          }}
        >
          {t("register.banner_subtitle")}
        </Typography>
      )}
      {LANGUAGE === LanguagesEnum.LT && (
        <List sx={{ pb: 10 }}>
          <StyledListItem>{t("register.banner_all_payments_in_one_place")}</StyledListItem>
          <StyledListItem>{t("register.banner_payment_with_single_login")}</StyledListItem>
          <StyledListItem>{t("register.banner_free_housing_services")}</StyledListItem>
          <StyledListItem>{t("register.banner_automatic_refresh")}</StyledListItem>
          <StyledListItem>{t("register.banner_notifications_about_pending_payments")}</StyledListItem>
        </List>
      )}
      {LANGUAGE === LanguagesEnum.PL && (
        <List>
          <StyledListItem>{t("register.banner_free_payment")}</StyledListItem>
          <StyledListItem>{t("register.banner_service_list")}</StyledListItem>
          <StyledListItem>{t("register.banner_automatic_refresh")}</StyledListItem>
        </List>
      )}
      {LANGUAGE === LanguagesEnum.PL && (
        <Typography
          fontWeight="bold"
          component="span"
          sx={{ marginTop: "auto", marginBottom: theme.spacing(3), fontSize: theme.typography.subtitle1.fontSize }}
        >
          {t("register.banner_cta")}
        </Typography>
      )}
    </Box>
  );
};

export default RegistrationBanner;
